// "Autónomo" (ticket 072, W8): the client's three answers and the engine's estimates, labelled
// as estimates. No revenue / expense / net rows (the income table has them) and no range bar.
import React from 'react'
import { FactGroup, SourceCardHeader } from './BriefParts'

export function AutonomoCard({ autonomo }) {
  if (!autonomo) return null
  return (
    <div className="brief-source-card completed">
      <SourceCardHeader title="Autónomo" />
      <div className="brief-source-card-body">
        <FactGroup title="Client's answers" facts={autonomo.answers} />
        {autonomo.estimates.length > 0 && <FactGroup title="Engine estimates" facts={autonomo.estimates} />}
      </div>
    </div>
  )
}
